import React from "react";

import WalletWithdrawals from "./index";

/**
 * USD (FIRC foreign-compartment) withdrawal section (TMG-2249). Lists the
 * export-earnings withdrawals of FIRC-enabled creators, which are settled
 * manually in USD.
 */
const USDWalletWithdrawals = () => {
  return <WalletWithdrawals currency="USD" />;
};

export default USDWalletWithdrawals;
